<template>
  <div class="content-part content" v-if="extras.successResult">
    <div
      class="t-success-new"
      v-if="category && extraItem.extras('userCategory.text') == 'show'"
    >
      {{ extras | extra("userCategory.content2") }} : {{ translatedCategory }}
    </div>
    <div
      class="t-success"
      v-show="extras.successType.type == 'code'"
      :style="{
        border:
          extraItem.extras('qrcodeborderdisplay.display', 1) == 1
            ? '1px solid #e9e9e9'
            : '0px',
      }"
    >
      <div
        class="code-tip"
        v-if="extraItem.extras('qrcodedisplay.display', 1) == 1"
      >
        {{ $t("success.credential") }}
      </div>
      <div
        class="code-qrcode"
        :class="platform"
        id="signUpQrCode"
        style="overflow: hidden"
      ></div>
      <!-- eslint-disable-next-line -->
      <div class="code-person">{{ $t("success.attendeeId") }}：{{ contactId }}</div>
    </div>
    <div class="t-success-new" v-show="extras.successType.type == 'result'">
      <!-- <div class="code-tip">参会凭证</div> -->

      <div class="code-qrcode">
        <img :src="extraItem.extras('exemResult.src')" alt="" />
      </div>
      <!-- <div class="code-person">参会人ID：{{ contactId }}</div> -->
    </div>
    <div
      class="t-success-new"
      v-if="extras.successResult.text != 'hide'"
      :style="{
        color:
          extras.successResult.text == 'custom'
            ? extras.successResult.fontColor
            : '',
        'font-size':
          platform != 'wap' && extras.successResult.text == 'custom'
            ? extras.successResult.fontSize + 'px'
            : '',
        'font-style':
          extras.successResult.text == 'custom'
            ? extras.successResult.fontTilt == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.successResult.text == 'custom'
            ? extras.successResult.fontWeight == 'on'
              ? 'bolder'
              : ''
            : '',
      }"
    >
      {{ extras | extra("successResult.content") }}
    </div>
    <div
      class="t-success-desc-new"
      v-if="extras.successResult.text2 != 'hide'"
      :style="{
        color:
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontColor2
            : '',
        'font-size':
          platform != 'wap' && extras.successResult.text2 == 'custom'
            ? extras.successResult.fontSize2 + 'px'
            : '',
        'font-style':
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontTilt2 == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontWeight2 == 'on'
              ? 'bolder'
              : ''
            : '',
      }"
    >
      {{ extras | extra("successResult.content2") }}
      <!-- </div> -->
    </div>
    <div
      class="u-post-new"
      v-if="platform == 'pc' && extraItem.extras('successButton.display') == 1"
    >
      <a-button
        class="submit"
        type="primary"
        :style="{
          display:
            extraItem.extras('successButton.type') == 'link' ? 'block' : 'none',
        }"
        @click="gotoUrl(extraItem.extras('successButton.link_link'))"
      >
        {{ extras | extra("successButton.link_text") }}
      </a-button>
    </div>
    <div
      class="u-post"
      v-if="platform == 'wap' && extraItem.extras('successButton.display') == 1"
    >
      <a-button
        class="submit"
        type="primary"
        :style="{
          display:
            extraItem.extras('successButton.type') == 'poster'
              ? 'block'
              : 'none',
        }"
        :disabled="posterInfo.poster && posterInfo.poster.status != undefined"
        @click="goInvite()"
      >
        {{ extras | extra("successButton.poster_text") }}
      </a-button>

      <a-button
        class="submit"
        type="primary"
        :style="{
          display:
            extraItem.extras('successButton.type') == 'link' ? 'block' : 'none',
        }"
        @click="gotoUrl(extraItem.extras('successButton.link_link'))"
      >
        {{ extras | extra("successButton.link_text") }}
      </a-button>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import * as sbaseData from "../common/sbase";
export default {
  name: "SuccessCon",
  props: ["platform", "posterInfo", "category"],
  data() {
    return {
      visible: false,
      needVerify: "",
      contactId: "",
    };
  },
  mounted() {
    this.needVerify = sbaseData.needVerify;

    this.contactId = sbaseData.contactId;
  },
  watch: {
    extras: {
      handler: function (n) {
        console.log(this, n);
        if (this.extras.successResult) {
          setTimeout(() => {
            new QRCode("signUpQrCode", {
              text: sbaseData.qrCode, //任意内容
              colorDark: "#000",
              colorLight: "#fff",
            });
          }, 0);
        }
      },
      immediate: true,
    },
  },
  computed: {
    extras() {
      return this.$store.state.extras;
    },
    translatedCategory() {
      if (!this.category) return "";
      // 将中文 category 映射到翻译 key
      const categoryMap = {
        普通参会人员: "success.category_normal",
      };
      const key = categoryMap[this.category];
      return key ? this.$t(key) : this.category;
    },
  },
  methods: {
    goInvite() {
      if (!sbaseData.isSetting) {
        this.$parent.goInvite();
      }
    },
    gotoUrl(url) {
      window.$sk.goto(url, true).subscribe((url) => {
        window.open(url);
      });
    },
  },
};
</script>
